import { AnalysisSource } from "../Enums/AnalysisSource";
import { AnalysisStatus } from "../Enums/AnalysisStatus";
import { IReportType } from "./IReportType";

export interface IAnalysisItem {
  id: number;
  jobId: string;
  createdByUserId: number;
  cid: number;
  startDateTime: Date;
  endDateTime: Date;
  createdDateTime: Date;
  source: AnalysisSource;
  studyAreaCount: number;
  status: AnalysisStatus;
  name: string;
  type: IReportType;
}
